import React from "react";

interface ListView {
  isSelected: boolean;
}

export const ListViewIcon: React.FC<ListView> = ({ isSelected }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      {isSelected ? (
        <g clipPath="url(#clip0_2034_5199)">
          <path
            d="M17.0602 15.455H5.0859C4.59238 15.455 4.19238 15.055 4.19238 14.5615C4.19238 14.068 4.59238 13.668 5.0859 13.668H17.0599C17.5534 13.668 17.9534 14.068 17.9534 14.5615C17.9534 15.055 17.5537 15.455 17.0602 15.455Z"
            fill="#215383"
          />
          <path
            d="M17.0602 9.8466H5.0859C4.59238 9.8466 4.19238 9.44661 4.19238 8.95309C4.19238 8.45957 4.59238 8.05957 5.0859 8.05957H17.0599C17.5534 8.05957 17.9534 8.45957 17.9534 8.95309C17.9537 9.44661 17.5537 9.8466 17.0602 9.8466Z"
            fill="#215383"
          />
          <path
            d="M17.0602 4.23723H5.0859C4.59238 4.23723 4.19238 3.83723 4.19238 3.34371C4.19238 2.85019 4.59238 2.4502 5.0859 2.4502H17.0599C17.5534 2.4502 17.9534 2.85019 17.9534 3.34371C17.9534 3.83723 17.5537 4.23723 17.0602 4.23723Z"
            fill="#215383"
          />
          <path
            d="M1.24589 4.61288C1.90863 4.61288 2.44589 4.07562 2.44589 3.41288C2.44589 2.75015 1.90863 2.21289 1.24589 2.21289C0.583154 2.21289 0.0458984 2.75015 0.0458984 3.41288C0.0458984 4.07562 0.583154 4.61288 1.24589 4.61288Z"
            fill="#215383"
          />
          <path
            d="M1.24589 10.1519C1.90863 10.1519 2.44589 9.61468 2.44589 8.95195C2.44589 8.28921 1.90863 7.75195 1.24589 7.75195C0.583154 7.75195 0.0458984 8.28921 0.0458984 8.95195C0.0458984 9.61468 0.583154 10.1519 1.24589 10.1519Z"
            fill="#215383"
          />
          <path
            d="M1.24589 15.692C1.90863 15.692 2.44589 15.1547 2.44589 14.492C2.44589 13.8292 1.90863 13.292 1.24589 13.292C0.583154 13.292 0.0458984 13.8292 0.0458984 14.492C0.0458984 15.1547 0.583154 15.692 1.24589 15.692Z"
            fill="#215383"
          />
        </g>
      ) : (
        <g clipPath="url(#clip0_2034_5199)">
          <path
            d="M17.0602 15.455H5.0859C4.59238 15.455 4.19238 15.055 4.19238 14.5615C4.19238 14.068 4.59238 13.668 5.0859 13.668H17.0599C17.5534 13.668 17.9534 14.068 17.9534 14.5615C17.9534 15.055 17.5537 15.455 17.0602 15.455Z"
            fill="#9D9D9D"
          />
          <path
            d="M17.0602 9.8466H5.0859C4.59238 9.8466 4.19238 9.44661 4.19238 8.95309C4.19238 8.45957 4.59238 8.05957 5.0859 8.05957H17.0599C17.5534 8.05957 17.9534 8.45957 17.9534 8.95309C17.9537 9.44661 17.5537 9.8466 17.0602 9.8466Z"
            fill="#9D9D9D"
          />
          <path
            d="M17.0602 4.23723H5.0859C4.59238 4.23723 4.19238 3.83723 4.19238 3.34371C4.19238 2.85019 4.59238 2.4502 5.0859 2.4502H17.0599C17.5534 2.4502 17.9534 2.85019 17.9534 3.34371C17.9534 3.83723 17.5537 4.23723 17.0602 4.23723Z"
            fill="#9D9D9D"
          />
          <path
            d="M1.24589 4.61288C1.90863 4.61288 2.44589 4.07562 2.44589 3.41288C2.44589 2.75015 1.90863 2.21289 1.24589 2.21289C0.583154 2.21289 0.0458984 2.75015 0.0458984 3.41288C0.0458984 4.07562 0.583154 4.61288 1.24589 4.61288Z"
            fill="#9D9D9D"
          />
          <path
            d="M1.24589 10.1519C1.90863 10.1519 2.44589 9.61468 2.44589 8.95195C2.44589 8.28921 1.90863 7.75195 1.24589 7.75195C0.583154 7.75195 0.0458984 8.28921 0.0458984 8.95195C0.0458984 9.61468 0.583154 10.1519 1.24589 10.1519Z"
            fill="#9D9D9D"
          />
          <path
            d="M1.24589 15.692C1.90863 15.692 2.44589 15.1547 2.44589 14.492C2.44589 13.8292 1.90863 13.292 1.24589 13.292C0.583154 13.292 0.0458984 13.8292 0.0458984 14.492C0.0458984 15.1547 0.583154 15.692 1.24589 15.692Z"
            fill="#9D9D9D"
          />
        </g>
      )}

      <defs>
        <clipPath id="clip0_2034_5199">
          <rect width="17.907" height="17.907" fill="white" transform="translate(0.046875)" />
        </clipPath>
      </defs>
    </svg>
  );
};
